
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z","fill":"#FFE4D6"}}),_c('path',{attrs:{"d":"M20 10c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm4.207 12.793l-1.414 1.414L20 21.414l-2.793 2.793-1.414-1.414L18.586 20l-2.793-2.793 1.414-1.414L20 18.586l2.793-2.793 1.414 1.414L21.414 20l2.793 2.793z","fill":"#FF3232"}})])
          )
        }
      }
    